import React, { useState, useEffect } from "react";
import {
  TextField,
  InputLabel,
  makeStyles,
  ListItemText,
  MenuItem,
  Chip,
} from "@material-ui/core";
import Checkbox from "../Checkbox";
import styles from "../styles";

const useStyles = makeStyles(styles);

const MultiSelect = (props) => {
  const {
    options,
    label,
    labelIcon,
    initialValues,
    changeHandler,
    disabled,
    required,
    placeholder,
    displayType = "tag",
  } = props;

  useEffect(() => {
    setValues(initialValues || "");
  }, [initialValues]);

  const [values, setValues] = useState(initialValues || "");

  const classes = useStyles();

  const handleChange = (e) => {
    setValues(e.target.value);
    if (changeHandler !== undefined && typeof changeHandler === "function") {
      changeHandler(e.target.value);
    }
  };

  const renderSelectedItems = (selected) => {
    const selectedOptions = options.filter(
      (o) => selected.indexOf(o.value || o) > -1,
    );
    if (displayType === "chip") {
      return (
        <div className={classes.chips}>
          {selectedOptions.map((value) => (
            <Chip
              key={value.value || value}
              label={value.label || value}
              className={classes.chip}
            />
          ))}
        </div>
      );
    } else {
      return selectedOptions.map((o) => o.label || o).join(", ");
    }
  };

  const renderItems = () => {
    if (displayType === "chip") {
      return options.map((option) => {
        const className =
          values && values.indexOf(option) >= 0 ? "selectedOption" : "";
        return (
          <MenuItem
            key={option.value || option}
            value={option.value || option}
            className={className}
          >
            {option.label || option}
          </MenuItem>
        );
      });
    } else {
      return options.map((option) => {
        return (
          <MenuItem key={option.value || option} value={option.value || option}>
            <Checkbox
              checked={values && values.indexOf(option.value || option) >= 0}
            />
            <ListItemText primary={option.label || option} />
          </MenuItem>
        );
      });
    }
  };

  return (
    <>
      <InputLabel className={classes.inputLabel}>
        {label}
        {required && (
          <span
            aria-hidden="true"
            className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
            style={{ color: "#E30613" }}
          >
            &thinsp;*
          </span>
        )}
        {labelIcon}
      </InputLabel>
      <TextField
        size="small"
        margin="dense"
        variant="outlined"
        value={values || []}
        fullWidth
        className={classes.inputField}
        onChange={handleChange}
        select
        disabled={disabled}
        placeholder={placeholder}
        SelectProps={{
          multiple: true,
          renderValue: renderSelectedItems,
        }}
      >
        {renderItems()}
      </TextField>
    </>
  );
};

export default MultiSelect;
